import React from 'react';
import { Box, ListItemText, MenuItem, Typography } from '@mui/material';
import SmallRadio from './SmallRadio';
import styles from './items.module.css';
import DividerWithMargin from '../dividers/DividerWithMargin';

export default function SelectItemRadio({
    title,
    checked = false,
    onSelect,
    disabled = false,
    showDivider = true,
    boldTitle = true,
    className = '',
}) {
    const handleRowClick = () => {
        if (!disabled) {
            onSelect();
        }
    };

    const handleRadioChange = (event) => {
        event.stopPropagation();
        if (!disabled) {
            onSelect();
        }
    };

    return (
        <>
            <MenuItem className={`${styles.item} ${className}`} onClick={handleRowClick} disabled={disabled}>
                <ListItemText disableTypography>
                    <Box className={styles.selectItemContent}>
                        <Typography className={boldTitle ? styles.selectTitleText : styles.selectTitleTextNormal}>
                            {title}
                        </Typography>
                        <Box className={styles.selectRadioControl}>
                            <SmallRadio checked={!!checked} onChange={handleRadioChange} />
                        </Box>
                    </Box>
                </ListItemText>
            </MenuItem>
            {showDivider && <DividerWithMargin margin={'16px'} />}
        </>
    );
}
